<template>
  <div>
    <review-list
        :key="this.profile.occupation_id"
        :occupation_id ="this.profile.occupation_id"
        :service_providers_id="this.profile.service_provider.id"
        :occupation_name="this.profile.occupationName"
        :isMainHeader="false" />
  </div>
</template>

<script>
import ReviewList from '@/components/Reviews';

export default {
  name: 'account-reviews',
  components: {
    ReviewList,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
};
</script>
